import { useAuth } from "~utils/hooks/use-auth"
import { useOutfitterContext } from "~contexts/outfitter-provider"

export default function useAuthenticatedOutfitter() {
    const { isAuthenticated, isLoading: isAuthLoading } = useAuth()
    const { outfitterId, isLoading: isPortalLoading } = useOutfitterContext()

    const isReady =
        isAuthenticated && !isAuthLoading && !isPortalLoading && !!outfitterId

    return { isReady, outfitterId: outfitterId ?? "" }
}
